import { DeepPartial } from '@apollo/client/utilities';
import { GetNazioneQuery } from '../../_graphql/generated';

export type NazioneState = {
  loading: boolean;
  lista: DeepPartial<GetNazioneQuery['unita_amministrativa_nazione']>;
  failure: any;
};

export const initialNazioneState: NazioneState = {
  loading: false,
  lista: [],
  failure: '',
};
